import n from"./document-all.js";var l=n,o=l.all,e=l.IS_HTMLDDA?function(t){return typeof t=="function"||t===o}:function(t){return typeof t=="function"};export{e as default};
